export default __webpack_public_path__ + "static/media/azure-log-analytics.2823e1b6.svg";